import { useProduct } from '@/hooks/useApi.js';
import { Layout } from '@/components/layout/Layout';

export default function TestProductPage() {
  console.log('%c[TestProductPage] Component rendered', 'color: pink; font-weight: bold;');
  
  // Test with a hardcoded product ID that we know exists
  const productId = "288";
  console.log('%c[TestProductPage] Using hardcoded productId:', 'color: pink;', productId);
  
  const { data: product, isLoading, error, isFetching } = useProduct(productId);

  console.log('%c[TestProductPage] Hook result:', 'color: pink;', {
    product,
    isLoading,
    error,
    isFetching
  });

  if (isLoading) {
    return <Layout><div>Loading...</div></Layout>;
  }

  if (error) {
    return <Layout><div>Error: {error.message}</div></Layout>;
  }

  if (!product) {
    return <Layout><div>No product found</div></Layout>;
  }

  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <h1>Test Product Page</h1>
        <h2>Product: {product.productName}</h2>
        <p>ID: {product.productId}</p>
        <p>Description: {product.productDescription}</p>
        <pre style={{ background: '#f5f5f5', padding: '10px', fontSize: '12px' }}>
          {JSON.stringify(product, null, 2)}
        </pre>
      </div>
    </Layout>
  );
}